import React from 'react'

const Contact = () => {
  return (
    <div>
       <h1 className='center fw-bolder fs-30'>Contact</h1>
    </div>
  )
}

export default Contact
